import styled, { css } from 'styled-components';
import { H1Text } from '@prisjakt/ui/text/variants';
import { layout, media } from 'src/components/base';

export const Hero = styled.div<{
  $active: boolean;
  $backgroundImage: string;
  $fullWidth: boolean;
  $hasRecentSearches: boolean;
}>`
  width: 100%;
  max-width: 980px;
  height: 234px;
  display: flex;
  justify-content: center;
  background-size: cover;
  background-position: center;
  margin: auto;
  padding: ${layout.measurements.spacing150};
  margin-top: ${layout.measurements.spacing050};
  flex-wrap: wrap;

  ${p => media.smallOnly`
    height: auto;
    padding:
    ${layout.measurements.spacing150}
    ${layout.measurements.spacing150}
    ${
      p.$hasRecentSearches
        ? layout.measurements.spacing100
        : layout.measurements.spacing300
    }
    ${layout.measurements.spacing150};
    margin-top: 0;
    background-color: ${p.theme.colors.maybeBlue500};
  `}

  ${p => (!p.$active ? 'height: 0; overflow: hidden;' : '')}
  ${p =>
    p.$fullWidth &&
    css`
      margin-top: 0;
      max-width: unset;
    `}
  ${p => media.mediumUp`
    background-image: url(${p.$backgroundImage});
  `}
`;

export const Content = styled.div<{
  $oneLineTitle: boolean;
}>`
  flex-grow: 1;
  max-width: 500px;
  color: ${p => p.theme.colors.base0};
  ${p => media.mediumUp`
    margin-top: ${
      p.$oneLineTitle
        ? layout.measurements.spacing200
        : layout.measurements.spacing125
    };
  `}
`;

export const SearchWrapper = styled.div`
  top: 0;
  z-index: 108;
`;

export const HeroTitle = styled(H1Text)<{
  $oneLineTitle: boolean;
  $biggerFontSize: boolean;
}>`
  white-space: pre;
  text-align: center;
  ${() => media.smallOnly`
    white-space: initial;
    margin-bottom: ${layout.measurements.spacing100};
  `}
  ${p => p.$oneLineTitle && `font-weight: 800;`}
  ${p => media.mediumUp`
    ${
      p.$oneLineTitle
        ? `font-size: ${p.$biggerFontSize ? '50px' : '40px'}; margin-bottom: ${
            p.$biggerFontSize
              ? layout.measurements.spacing100
              : layout.measurements.spacing200
          };`
        : `margin-bottom: ${layout.measurements.spacing100};`
    }
  `}
`;
